import CloseIcon from '@portalterreno/react-ui-icons/CloseIcon';
import MenuIcon from '@portalterreno/react-ui-icons/MenuIcon';
import React, { memo } from 'react';

import StyledDivIcon from './StyledDivIcon';

type MenuMobileProps = React.HTMLAttributes<HTMLDivElement> & {
  isMenuOpen: boolean;
};

const MenuMobileIcon: React.FC<MenuMobileProps> = ({ isMenuOpen, ...rest }) => {
  return (
    <StyledDivIcon {...rest}>
      {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
    </StyledDivIcon>
  );
};

export default memo(MenuMobileIcon);
